/*
 * @Version: 1.0 常量配置
 * @Autor: wenruihuan
 * @Date: 2022-04-01 00:58:31
 * @LastEditTime: 2022-04-21 22:25:28
 */

export default {
    tableMinWidth: 1200,
    // serverUrl: 'http://139.9.36.59:8081',
    // Url: '192.168.5.251:8081',
    // Url: '192.168.5.35:8081',
    // Url: '139.9.36.59:8081',
    // Url: '113.45.40.72:8081',
    Url: window.location.host,
    // serverUrl: 'http://192.168.5.251:8081',
    // serverUrl: 'http://192.168.5.35:8081',
    // serverUrl: 'http://113.45.40.72:8081',
    // serverUrl: 'http://139.9.36.59:8081',
    serverUrl:'',


    // serverUrl: 'http://'+window.location.hostname+':9527',
    // videoUrl: 'http://121.36.163.135:10000/#/screen',
    videoUrl: 'http://'+window.location.hostname+':11000',
    // 播放模式
    languagesType: [
        // {value: '1',  name: '粤语男声'},
        // {value: '2',  name: '粤语女声'},
        {value: '3',  name: '普通话男'},
        {value: '4',  name: '普通话女'},
    ],
    // 语速
    languageSpeed: [
        {value: '40',  name: '慢'},
        {value: '45',  name: '较慢'},
        {value: '50',  name: '正常'},
        {value: '55',  name: '较快'},
        {value: '60',  name: '快'},
    ],
    // 播放模式
    palyModel: [
        {id: '1',  name: '单曲播放'},
        {id: '2',  name: '单曲循环'},
        {id: '3',  name: '列表播放'},
        {id: '4',  name: '列表循环'},
        {id: '5',  name: '随机播放'}
    ],
    // 播放模式
    EnglishPalyModel: [
        {id: '1',  name: "single playback"},
        {id: '2',  name: "single cycle"},
        {id: '3',  name: "list playback"},
        {id: '4',  name: "list loop"},
        {id: '5',  name: "shuffle"}
    ],
    // 音量设置
    volumeModel: [
        {id: '255',  name: '默认音量'},
        {id: 'auto', name: '自定义音量'}
    ],
    // 音量设置
    EnglishVolumeModel: [
        {id: '255',  name: 'default volume'},
        {id: 'auto', name: 'custom volume'}
    ],
    // 音源
    soundSource: [
        { id: '00', name: '本地MP3'},
        { id: '01', name: '本地话筒' },
        { id: '02', name: '本地线路1' },
        { id: '03', name: '本地线路2' },
        { id: '04', name: '平台媒体库' },
        { id: '05', name: 'IP话筒点播平台' },
        { id: '06', name: '话筒U盘音乐' },
        { id: '07', name: '话筒麦克风' },
        { id: '08', name: '上级终端' },
        { id: '09', name: '其它' },
        { id: '10', name: '无音源' },
        { id: '11', name: '手机喊话' },
        { id: '12', name: '手机音乐' },
        { id: '13', name: '消防报警' },
        { id: '14', name: '服务器声卡' },
        { id: '15', name: '文字转语音' },
        { id: '16', name: '预留' },
        { id: '17', name: '话筒线路' },
        { id: '18', name: '话筒麦克风' },
        { id: '19', name: '终端音频（针对话筒监听）' },
        { id: '20', name: '终端音频（针对话筒监听）' },
        { id: '21', name: '终端视频（针对话筒监看）' },
        { id: '22', name: '蓝牙' },
        { id: '23', name: '2.4G' },
        { id: '24', name: '终端报警' },
        { id: '25', name: '平台视频库' },
        { id: '26', name: '本地视频库' },
        { id: '27', name: '频道' }
    ],
    // 设备状态
    deviceState: [
        { id: '00', name: '空闲状态'},
        { id: '01', name: '本地应急广播'},
        { id: '02', name: '本地日常广播'},
        { id: '03', name: '分区广播'},
        { id: '04', name: '定时广播'},
        { id: '05', name: '电话广播'},
        { id: '06', name: 'FM转播'},
        { id: '07', name: 'IP日常广播'},
        { id: '08', name: 'DTMB广播'},
        { id: '09', name: '平台控播'},
        { id: '10', name: 'DVB广播'},
        { id: '11', name: '本地终端采播'},
        { id: '12', name: '录音回放'},
        { id: '13', name: 'IP应急广播'},
        { id: '14', name: '话筒采播'},
        { id: '15', name: '话筒采播'},
        { id: '16', name: '话筒点播'},
        { id: '17', name: '话筒点播'},
        { id: '18', name: '监听'},
        { id: '19', name: '监看'},
        { id: '20', name: '对讲'},
        { id: '21', name: '视频播放'},
        { id: '22', name: '频道点播'},
    ],
    // 请求状态
    responseCode: [
        { id: '0', name: '成功'},
        { id: '10001', name: '请输入或选择必要字段'},
        { id: '10002', name: '账号或密码错误'},
        { id: '10003', name: '文件过大错误'},
        { id: '10004', name: '用户不存在'},
        { id: '10005', name: '用户没有所在单位'},
        { id: '10006', name: '用户已存在'},
        { id: '10007', name: '用户不存在'},
        { id: '10008', name: '数据格式异常'},
        { id: '10009', name: '任务不存在'},
        { id: '10010', name: '设备不存在'},
        { id: '10011', name: '设备离线'},
        { id: '10012', name: '验证码错误'},
        { id: '10013', name: '验证码过期'},
        { id: '10014', name: '文件不存在'},
        { id: '10015', name: '文件名存在'},
        { id: '10016', name: '设备ipid已经存在'},
        { id: '10017', name: '声卡已占用'},
        { id: '10018', name: '声卡采集未启用'},
        { id: '10019', name: '任务类型不符'},
        { id: '10020', name: '没有上一首'},
        { id: '10021', name: '没有下一首'},
        { id: '10022', name: '任务存在'},
        { id: '10023', name: '设备或单位名称已存在'},
        { id: '10024', name: '任务暂停中，无法播放'},
        { id: '10025', name: '任务停止中，无法开启'},
        { id: '10026', name: '定时方案不存在'},
        { id: '10027', name: '设备不支持rds'},
        { id: '10028', name: '定时方案不存在'},
        { id: '10029', name: '只能绑定一台设备'},
        { id: '10030', name: '该通道已经绑定'},
        { id: '10031', name: '设备正在响应'},
        { id: '10032', name: '任务未使用'},
        { id: '10033', name: '用户权限不足'},
        { id: '10034', name: '文件解压失败'},
        { id: '10035', name: '数据库正在备份中'},
        { id: '10036', name: '注册码错误'},
        { id: '10037', name: '注册码过期'},
        { id: '10038', name: '注册数量上限'},
        { id: '10039', name: '音量超出'},
        { id: '10040', name: '请选择被监听设备'},
        { id: '10041', name: '请选择播放终端'},
        { id: '10042', name: '该用户禁止删除'},
        { id: '10043', name: 'IPID长度不对（必须8位）'},
        { id: '10044', name: 'RDS不正确，每位都要1~255'},
        { id: '10045', name: 'RDS已存在'},
        { id: '10046', name: '当前设备没有任务'},
        { id: '10047', name: '设备响应超时'},
        { id: '10048', name: '登录超时'},
        { id: '10049', name: '实时任务正在使用该音频，删除失败'},
        { id: '10050', name: '定时任务正在使用该音频，删除失败'},
        { id: '10051', name: '设备异常'},
        { id: '10052', name: '文件类型不匹配'},
        { id: '10053', name: '优先级错误'},
        { id: '10054', name: '账户登录错误次数太多，已经冻结'},
        { id: '10055', name: '任务占用该设备（请检查实时任务或定时任务是否绑定）'},
        { id: '10056', name: '频率异常，请输入76~108'},
        { id: '10057', name: '播放模式异常，(歌曲数量大于1，请选择列表模式)'},
        { id: '10058', name: '时间或日期选择异常'},
        { id: '10059', name: 'freeswitch插件未启动，请检查服务器配置'},
        { id: '10060', name: '无绑定数据'},
        { id: '10061', name: '该方案禁止删除'},
        { id: '10062', name: '任务进行中,禁止操作'},
        { id: '10063', name: '99998000->99999999段禁止使用'},

        { id: '20000', name: '服务器异常，未知异常'},
        { id: '20001', name: '数据插入异常'},
        { id: '20002', name: '数据删除异常'},
        { id: '20003', name: '数据修改异常'},
    ],
    EnglishResponseCode: [
        { id: '0', name: 'success'},
        { id: '10001', name: 'please enter or select the necessary fields'},
        { id: '10002', name: 'account or password error'},
        { id: '10003', name: 'file size error'},
        { id: '10004', name: 'user does not exist'},
        { id: '10005', name: 'the user does not have a unit'},
        { id: '10006', name: 'user already exists'},
        { id: '10007', name: 'user does not exist'},
        { id: '10008', name: 'abnormal data format'},
        { id: '10009', name: 'task does not exist'},
        { id: '10010', name: 'device does not exist'},
        { id: '10011', name: 'device offline'},
        { id: '10012', name: 'verification code error'},
        { id: '10013', name: 'verification code expired'},
        { id: '10014', name: 'file does not exist'},
        { id: '10015', name: 'file name exists'},
        { id: '10016', name: 'device ipid already exists'},
        { id: '10017', name: 'server acquisition and playback are already occupied'},
        { id: '10018', name: 'server playback not enabled'},
        { id: '10019', name: 'task type mismatch'},
        { id: '10020', name: 'no previous song'},
        { id: '10021', name: 'no next song'},
        { id: '10022', name: 'task exists'},
        { id: '10023', name: 'node name exists'},
        { id: '10024', name: 'the task is paused and cannot be played'},
        { id: '10025', name: 'the task is stopping and cannot be opened'},
        { id: '10026', name: 'timing scheme does not exist'},
        { id: '10027', name: 'device does not support RDS'},
        { id: '10028', name: 'timing scheme does not exist'},
        { id: '10029', name: 'only one device can be bound'},
        { id: '10030', name: 'the channel has already been bound'},
        { id: '10031', name: 'device is responding'},
        { id: '10032', name: 'task not used'},
        { id: '10033', name: 'insufficient user permissions'},
        { id: '10034', name: 'file decompression failed'},
        { id: '10035', name: 'database is currently being backed up'},
        { id: '10036', name: 'registration code error'},
        { id: '10037', name: 'registration code expired'},
        { id: '10038', name: 'maximum number of registrations'},
        { id: '10039', name: 'volume exceeded'},
        { id: '10040', name: 'please select the monitored device'},
        { id: '10041', name: 'device not responding'},
        { id: '10042', name: 'the user is prohibited from deleting'},
        { id: '10043', name: 'incorrect length of IPID (must be 8 digits)'},
        { id: '10044', name: 'RDS is incorrect, everyone needs 1-255'},
        { id: '10045', name: 'RDS already exists'},
        { id: '10046', name: 'the current device has no tasks'},
        { id: '10047', name: 'device response timeout'},
        { id: '10048', name: 'login timeout'},
        { id: '10049', name: 'real time task is using this audio, deletion failed'},
        { id: '10050', name: 'the scheduled task is currently using this audio, deletion failed'},
        { id: '10051', name: 'device abnormality'},
        { id: '10052', name: 'file type mismatch'},
        { id: '10053', name: 'priority error'},
        { id: '10054', name: 'account freeze'},
        { id: '10055', name: 'task occupying the device (please check if real-time or scheduled tasks are bound)'},
        { id: '10056', name: 'abnormal frequency, please enter 76~108'},
        { id: '10057', name: 'abnormal playback mode, (number of songs greater than 1, please choose list mode)\n'},
        { id: '10058', name: 'Date or time selection exception'},
        { id: '20000', name: 'server exception, unknown exception'},
        { id: '20001', name: 'data insertion exception'},
        { id: '20002', name: 'data deletion exception'},
        { id: '20003', name: 'abnormal data modification'},
    ],
}
